__turbopack_context__.v({
  "flexColumn": "additional-requirements-module-scss-module__OjJLlW__flexColumn",
  "requirements": "additional-requirements-module-scss-module__OjJLlW__requirements",
  "requirements__conversion-factors-wrapper": "additional-requirements-module-scss-module__OjJLlW__requirements__conversion-factors-wrapper",
  "requirements__conversion-factors-wrapper--block": "additional-requirements-module-scss-module__OjJLlW__requirements__conversion-factors-wrapper--block",
  "requirements__monthly-goals-wrapper": "additional-requirements-module-scss-module__OjJLlW__requirements__monthly-goals-wrapper",
  "requirements__note-wrapper": "additional-requirements-module-scss-module__OjJLlW__requirements__note-wrapper",
  "requirements__note-wrapper--block": "additional-requirements-module-scss-module__OjJLlW__requirements__note-wrapper--block",
  "skeleton": "additional-requirements-module-scss-module__OjJLlW__skeleton",
});
